import React from 'react';
import CameraList from '../../../components/cameras/CameraList';

const ClientCameraTab = ({
  cameras,
  loading,
  error,
  onRefresh,
  formatHeartbeat,
  onPreview,
  previewLoading,
  pendingPreviewId,
}) => (
  <CameraList
    title="My cameras"
    description="Live feeds and health updates for cameras assigned to your account."
    cameras={cameras}
    loading={loading}
    error={error}
    onRefresh={onRefresh}
    formatHeartbeat={formatHeartbeat}
    onPreview={onPreview}
    previewLoading={previewLoading}
    pendingPreviewId={pendingPreviewId}
    emptyMessage="No cameras are linked to your profile yet. Contact your administrator if this seems incorrect."
  />
);

export default ClientCameraTab;
